<template>
  <section class="add-content">
    <div class="add-content__circle">
      <SvgPlus class="add-content__svg" />
      <span class="add-content__title">{{ title }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AddContent',

  components: {
    SvgPlus: () => import('@/assets/svgs/plus.svg?inline'),
  },

  props: {
    title: {
      type: String,
      default: 'title',
    },
  },
};
</script>

<style lang="scss" scoped>
.add-content {
  position: relative;
  height: 100%;
  width: 100%;
  @include flexbox(center, center);

  &__circle {
    @include flexbox(center, center);
    flex-direction: column;
    width: rem(420);
    height: rem(420);
    border: 1px solid #4094af;
    border-radius: 50%;
    cursor: pointer !important;
    position: relative;
  }

  &__svg {
    width: rem(60);
    margin-bottom: rem(20);

    path {
      fill: #4094af;
    }
  }

  &__title {
    font-size: rem(32);
    line-height: 1;
    color: #9b9b9b;
    font-weight: $font-light;
    max-width: rem(200);
    text-align: center;
  }

  @include iPadProStyles {
    &__circle {
      width: rem(500);
      height: rem(500);
    }

    &__title {
      font-size: rem(36);
    }

    &__svg {
      width: rem(80);
      margin-bottom: rem(30);
    }
  }
}
</style>
